'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _validateValue = require('../enhancers/validateValue');

var _validateValue2 = _interopRequireDefault(_validateValue);

var _inputByTyping = require('./inputByTyping');

var _inputByTyping2 = _interopRequireDefault(_inputByTyping);

var _defaultPropsByType = require('./defaultPropsByType');

var _defaultPropsByType2 = _interopRequireDefault(_defaultPropsByType);

var _autoFocusWhenLoaded = require('../enhancers/autoFocusWhenLoaded');

var _autoFocusWhenLoaded2 = _interopRequireDefault(_autoFocusWhenLoaded);

var _makeFormatter = require('../../../utils/makeFormatter');

var _makeFormatter2 = _interopRequireDefault(_makeFormatter);

var _mapPropsToFormatterSpec = require('../../../utils/makeFormatter/mapPropsToFormatterSpec');

var _mapPropsToFormatterSpec2 = _interopRequireDefault(_mapPropsToFormatterSpec);

var _makeParser = require('../../../utils/makeParser');

var _makeParser2 = _interopRequireDefault(_makeParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO process direct passing prop, like `format`
exports.default = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  type: _propTypes.string,
  value: _propTypes.any,
  onChange: _propTypes.func.isRequired,

  schema: _propTypes.object,
  block: _propTypes.object,

  formatter: _propTypes.func,
  parser: _propTypes.func
}), (0, _flattenDefaultProp2.default)('block'), (0, _flattenDefaultProp2.default)('schema'), (0, _withProps2.default)(function (_ref) {
  var type = _ref.type;
  return { type: type && type.toLowerCase() };
}), _defaultPropsByType2.default, (0, _branch2.default)(function (_ref2) {
  var formatter = _ref2.formatter;
  return !formatter;
}, (0, _withPropsOnChange2.default)(_mapPropsToFormatterSpec2.default.isEqualSpec, function (props) {
  return {
    formatter: (0, _compose2.default)(_makeFormatter2.default, _mapPropsToFormatterSpec2.default)(props)
  };
})), (0, _branch2.default)(function (_ref3) {
  var parser = _ref3.parser;
  return !parser;
}, (0, _withPropsOnChange2.default)(_makeParser2.default.isEqualSpec, function (props) {
  return { parser: (0, _makeParser2.default)(props) };
})), _validateValue2.default, _inputByTyping2.default, _autoFocusWhenLoaded2.default, (0, _exposeProps2.default)(['type', 'value', 'disabled', 'step', 'onChange', 'onFocus', 'onBlur', 'inputRef', 'isInvalid']));


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/inputEnhancer.js
// module id = 1672
// module chunks = 0